import _isEmpty from 'lodash-es/isEmpty';
import dayjs from 'dayjs';

/**
 * @param {any} data
 * @returns {boolean}
 */
export function isEmpty(data) {
	if (typeof data == 'number') {
		return data === 0;
	} else if (typeof data === 'boolean') {
		return !data;
	} else {
		return _isEmpty(data);
	}
}

/**
 * @param {any|string} value
 * @return {string}
 */
function toClassName(value) {
	let result = '';

	if (typeof value === 'string' || typeof value === 'number') {
		result += value;
	} else if (typeof value === 'object') {
		if (Array.isArray(value)) {
			result = value.map(toClassName).filter(Boolean).join(' ');
		} else {
			for (let key in value) {
				if (value[key]) {
					result += (result != '' ? ' ' : '') + key;
				}
			}
		}
	}

	return result;
}

/**
 * @param { Array<any|string>} args
 * @return {string}
 */
export const classnames = (...args) => args.map(toClassName).filter(Boolean).join(' ');

export function redirectOldSystem() {
	window.location.reload();

	// const newUrl = page.url.href
	// 	.toString()
	// 	.replace(page.url.origin, /* 'http://localhost:8081' */ 'http://dev1.d.clserv.de')
	// 	.replace(base, '');
	//
	// console.log('redirect to', newUrl);
	//
	// window.location = newUrl;
}

/**
 * @param {Date} date
 * @returns {string}
 */
export function RangeDate(date) {
	return dayjs(date).format('YYYY-MM-DD[T]HH:mm:ssZ');
}
